/**
 * DON'T EDIT THIS FILE MANUALLY!
 * This file is auto-generated during the build process.
 * It contains metadata about the build such as build time and version.
 */

/** @ts-ignore */
const platform: "web-editor" | "chrome-extension" = "{{BUILD_PLATFORM}}";
const time: number = Number("{{BUILD_TIME}}");
const date: string = "{{BUILD_DATE}}";
/** @ts-ignore */
const environment: "dev" | "production" = "{{BUILD_ENVIRONMENT}}";
const hash = "{{BUILD_HASH}}";
const changelog: string | null = `{{BUILD_CHANGELOG}}`?.trim();
const semver: string | null = "{{BUILD_SEMVER}}".trim() || null;

/** The target platform for this build */
export const BUILD_PLATFORM: typeof platform = platform;
/** The build time as a timestamp */
export const BUILD_TIME = time;
/** The build date as an ISO string */
export const BUILD_DATE = date;
/** The build environment, e.g. "dev" or "production" */
export const BUILD_ENVIRONMENT: typeof environment = environment;
/** The build hash, e.g. a git commit hash */
export const BUILD_HASH = hash;
/** The semantic version of this build */
export const BUILD_SEMVER = semver;

/** Get the changelog content in raw markdown format
 * @returns The changelog content as a string, or null if not available
 */
export function getChangelogRAW() {
    if (!changelog?.length) return null;
    return changelog;
}

